import {Link} from 'gatsby'
import React from 'react'
import styled from '@emotion/styled'
import BlogPostPreview from './blog-post-preview'



function BlogPostPreviewGrid (props) {
  return (
    <div>
      {/*
        {props.title && <h2>{props.title}</h2>}
      */}
      {props.nodes &&
        props.nodes.map((node, index) => {
          const isFirst = (index === 0) ? true : false

          // console.log(node.slug.current)

          return (
            <BlogPostPreview {...node} key={node.id} setNewsTitles={props.setNewsTitles} isFirst={isFirst} forwardRef={props.setRef(node.slug.current)} />
          )
        })
      }

      {props.browseMoreHref && (
        <div>
          <Link to={props.browseMoreHref}>Browse more</Link>
        </div>
      )}
    </div>
  )
}

BlogPostPreviewGrid.defaultProps = {
  title: '',
  nodes: [],
  browseMoreHref: ''
}

export default BlogPostPreviewGrid
